import { useCallback, useEffect, useState } from 'react'
import { intl } from '../../../../../i18n'
import sprint, { SprintStatus } from '../../../../../lib/functions/sprint'
import { SelectOption } from '../../../../model/selectOption'
import { CheckboxSelectConditionItemLabel } from '../CheckboxSelectConditionItemLabel'

type SprintMultiAutocompleteConditionItemLabelProps = {
  value: string[] | undefined
  teamUuid: string | undefined
  isLoading?: boolean
  onChange: (value: string[] | undefined) => void
  search: () => void
  onClose?: () => void
}

export const SprintMultiAutocompleteConditionItemLabel = ({
  value,
  teamUuid,
  isLoading,
  onChange,
  onClose,
  search,
}: SprintMultiAutocompleteConditionItemLabelProps) => {
  const [sprintOptions, setSprintOptions] = useState<SelectOption[]>([])

  // TODO: SprintStatusDisplayOrder に置き換える
  const getSortIndex = useCallback((status: SprintStatus) => {
    const sortedStatusList = [
      SprintStatus.INPROGRESS,
      SprintStatus.STANDBY,
      SprintStatus.FINISHED,
      SprintStatus.CANCELED,
    ]
    return sortedStatusList.findIndex(v => v === status)
  }, [])

  useEffect(() => {
    const fetchSprints = async () => {
      if (!teamUuid) {
        setSprintOptions([])
        return
      }
      const sprints = await sprint.searchByText(teamUuid)
      setSprintOptions(
        sprints
          .sort((a, b) => getSortIndex(a.status) - getSortIndex(b.status))
          .map(v => ({ value: v.uuid, name: v.name, groupBy: v.status }))
      )
    }
    fetchSprints()
  }, [teamUuid, getSortIndex])

  return (
    <CheckboxSelectConditionItemLabel
      header={intl.formatMessage({
        id: 'wbsItemSearchFilterPanel.sprint',
      })}
      value={value}
      onChange={onChange}
      onClose={onClose}
      search={search}
      options={sprintOptions}
      isLoading={isLoading}
    />
  )
}
